var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    {
      ref: "icon",
      staticClass: "icon",
      class: { "photo-lazyload": _vm.hasLazyload },
      style: { backgroundImage: _vm.backgroundImage },
      attrs: { "data-src": _vm.dataSrc },
      on: { click: _vm.onClick },
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }